import React from "react";
import {flushSync} from "react-dom";


class CommonOneFieldForm extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }

    async handleChange(event){
        let formData = new FormData(event.target);
        await this.props.callBack(formData)
    }

    async fieldCallBack(){
        flushSync(()=>{})
        this.handleChange(
            {target: this.form.current}
        )
    }

    render() {
        return(
            <form
                ref={this.form}
                onChange={this.handleChange.bind(this)}
            >
                <this.props.field.component
                    {...this.props.field.props}
                    callBack={this.fieldCallBack.bind(this)}
                />
            </form>
        )
    }
}

export default CommonOneFieldForm;